import Sidebar from "../../components/Sidebar/Sidebar-main";
import Header2 from "../../components/Header-2/Header2-main";
import HotelCard from "../../components/HotelCard/hotel";
import Footer from "../../components/Footer/Footer.main";
import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import SubHeader from "../../components/Subheader/subheader";
import { useNavigate } from "react-router-dom";
// import { useParams } from 'react-router-dom';
import Pagination from "../../components/Pagination/Pagination";
import { ColorRing, Grid, LineWave } from "react-loader-spinner";

// temporary amenities
const tempAmenities = [
  {
    id: 7,
    icon: {
      id: 7417,
      active_status: false,
      created_at: "2022-02-16T15:28:52.948530+05:30",
      updated_at: "2022-02-16T15:28:52.948550+05:30",
      name: null,
      type: "IMAGE",
      file: "https://icons8.com/icon/102741/wait",
      tags: [],
    },
    name: "Please Wait...",
    is_secondary: false,
    is_view: false,
  },
];

const VillaSearch = () => {
  const navigate = useNavigate();
  const Location = useLocation();
  const formData = Location.state;

  //console.log("YE RAHA DATA", formData);
  const { city: cityParam } = useParams();
  // alert(cityParam)
  const newcity = cityParam.replace('-',' ')
  const [villasData, setVillasData] = useState([]);
  const [amenities, setAmenities] = useState(tempAmenities);
  const [villalist, setVillalist] = useState(null);
  const [landmarklist, setlandmarklist] = useState(null);
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(8);
  const [pageQuery, setPageQuery] = useState("&page_number=1");
  const [queryPrefix, setQueryPrefix] = useState(
    "http://localhost:8000/api/v1/getAllVillas?"
  );
  const [locationQuery, setLocationQuery] = useState('');
  useEffect(() => {
    const city = formData?.location || cityParam || 'Lonavala';
    const adults = formData?.adults || 2;
    const children = formData?.children || 0;

    setLocationQuery(`city=${city}&adults=${adults}&children=${children}`);
  }, [cityParam, formData]);
  const [finalQuery, setFinalQuery] = useState("");
  const [SubHeaderQuery, setSubHeaderQuery] = useState("");

  // states for header
  const [location, setLocation] = useState(formData ? formData.location : newcity);
  const [adults, setAdults] = useState(formData ? formData.adults : 2);
  const [children, setChildren] = useState(formData ? formData.children : 0);
  const [startDate, setStartDate] = useState(
    formData ? formData.startDate : ""
  );
  const [endDate, setEndDate] = useState(formData ? formData.endDate : "");
  const [showModal, setShowModal] = useState(false)
  const handleAmenities = async () => {
    const res = await axios.get(
      `http://localhost:8000/api/v1/getAmenitiesCity?${locationQuery}`
    );
    // //console.log("AMEN", res.data.data);
    setAmenities(res.data.data);
    setlandmarklist(res.data.landmark);
    setVillalist(res.data.villas);
    // handleSearch();
  };
  useEffect(() => {
    handleAmenities();
  }, [locationQuery]);

  useEffect(() => {
    if (query !== "") {
      let temp =
        queryPrefix + locationQuery + query + SubHeaderQuery + pageQuery;
      setFinalQuery(temp);
      //console.log("Final query updated!");
      // //console.log("LOCATION - ", locationQuery);
      // //console.log("QUERY - ", query);
      //console.log("FINAL - ", temp);
    }
  }, [query, locationQuery, SubHeaderQuery, pageQuery]);

  const handleSearch = async () => {
    // let temp = queryPrefix + locationQuery + query;
    // setFinalQuery(temp);
    //console.log(finalQuery, "sed");
    const res = await axios.get(finalQuery);
    //console.log(res.data.data, "noice");
    setVillasData(res.data.data);
    // setAmenities(res.data.data2);
    // //console.log(locationQuery,"asds")
    //console.log(formData);
  };

  useEffect(() => {
    if (finalQuery !== "") {
      handleSearch();
    }
  }, [finalQuery]);

  const handleCardClick = (villaId, villaName) => {
    const formData2 = {
      villaId: villaId,
      villaName: villaName,
      location: location,
      startDate: startDate,
      endDate: endDate,
      adults: adults,
      children: children,
    };
    const hyphenatedVillaName = villaName.replace(/\s+/g, '-');
    navigate(`/villa/${villaId}/${hyphenatedVillaName}`, { state: formData2 });
  };
  
  const handleSearchClick = (a=false) => {
    let destination = location? location:newcity;
    let diffTime;
    if (endDate instanceof Date && startDate instanceof Date)
      diffTime = Math.abs(endDate.getTime() - startDate.getTime());
    else diffTime = 0;
    const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const tempStartDate = startDate instanceof Date ? startDate.toISOString().slice(0, 10) : null;
    let newEndDate = null;
    if (endDate instanceof Date) {
      newEndDate = new Date(endDate.getTime());
      newEndDate.setDate(newEndDate.getDate() - 1);
    }
    const tempEndDate = newEndDate?.toISOString().slice(0, 10);
  
    let temp = `city=${destination}&adults=${adults}&children=${children}&startDate=${tempStartDate}&endDate=${tempEndDate}&days=${days}`;
    //console.log(temp,"asddsaasddsa")
    setLocationQuery(temp);
    window.history.pushState(null, '', `/search/${destination.replace(' ','-')}`)
    // if (a) navigate(`/search/${destination.replace(' ','-')}`,{ replace: true });
  };
  
  

  useEffect(() => {
    handleSearchClick();
  }, []);

  return (
    <>
      {amenities != tempAmenities && villalist && landmarklist ? (
        <div className="">
          
          <div className="relative">
            <Header2
              setLocationQuery={setLocationQuery}
              location={location}
              setLocation={setLocation}
              setAdults={setAdults}
              adults={adults}
              children={children}
              setChildren={setChildren}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              handleSearchClick={handleSearchClick}
            />
          </div>
          <SubHeader
            setSubHeaderQuery={setSubHeaderQuery}
            villalist={villalist}
            landmarklist={landmarklist}
          />
          <div className="flex justify-between ">
            <div className="hidden lg:flex">
              <Sidebar
                amenities={amenities}
                query={query}
                setQuery={setQuery}
              />
            </div>
            {villasData.length > 0 ? (
              <div className="w-full mt-10  space-y-6 mb-10">
                {villasData.map((villadata) => {
                  return (
                    <div>
                      <HotelCard
                        villadata={villadata}
                        amenitiesAll={amenities}
                        handleCardClick={handleCardClick}
                        tempStartDate={formData?.startDate?.toISOString().slice(0, 10)}
                        tempEndDate={formData?.endDate?.toISOString().slice(0, 10)}
                      />
                    </div>
                  );
                })}
                <Pagination
                  totalPosts={80}
                  postsPerPage={postsPerPage}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  setPageQuery={setPageQuery}
                />
              </div>
            ) : (
              <div class="w-full mt-[30vh] flex justify-center mb-10">
                <Grid
                  height="80"
                  width="80"
                  color="#b59c9c"
                  ariaLabel="grid-loading"
                  radius="12.5"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                />
              </div>
            )}
          </div>

          <Footer />
        </div>
      ) : (
        <div class="flex justify-center items-center h-screen">
          <div class="flex flex-col justify-evenly my-auto mx-auto">
            <ColorRing
              visible={true}
              height="150"
              width="150"
              ariaLabel="blocks-loading"
              wrapperStyle={{}}
              wrapperClass="blocks-wrapper"
              colors={["#e15b64", "#f47e60", "#f8b26a", "#abbd81", "#849b87"]}
            />
            <div className="text-center text-[25px] font-hk">Please Wait</div>
          </div>
        </div>
      )}
    </>
  );
};

export default VillaSearch;
